import React from "react";

const MozoIcon = () => (
  <svg
    style={{ color: "#0f0f0f", fontSize: "16px", width: "16px", height: "16px" }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 14a6 6 0 1 1 12 0"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14h16"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 14c0 3.038 2.462 5.5 5.5 5.5h2c3.038 0 5.5-2.462 5.5-5.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.5v-1"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export default MozoIcon;
